import { render } from "./InstructionText.vue?vue&type=template&id=64ddc402&scoped=true"
import script from "./InstructionText.vue?vue&type=script&lang=js"
export * from "./InstructionText.vue?vue&type=script&lang=js"

import "./InstructionText.vue?vue&type=style&index=0&id=64ddc402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ddc402"]])

export default __exports__